export function alertsReducer(state = null,{
    type,
    payload
}){
    switch(type){
        case  "GET_ALERTS":
            return payload;
        
        case  "DELETE_ALERTS":
            let list = Object.assign({}, state)  
            delete list[payload]
            
            return list
        
        default:
            return state;
    }
}